import { render, staticRenderFns } from "./FloorPlanCanvas.vue?vue&type=template&id=59ed0cb8&scoped=true&"
import script from "./FloorPlanCanvas.vue?vue&type=script&lang=js&"
export * from "./FloorPlanCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FloorPlanCanvas.vue?vue&type=style&index=0&id=59ed0cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed0cb8",
  null
  
)

/* custom blocks */
import block0 from "./FloorPlanCanvas.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ed0cb8')) {
      api.createRecord('59ed0cb8', component.options)
    } else {
      api.reload('59ed0cb8', component.options)
    }
    module.hot.accept("./FloorPlanCanvas.vue?vue&type=template&id=59ed0cb8&scoped=true&", function () {
      api.rerender('59ed0cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/FloorPlanCanvas.vue"
export default component.exports